<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-月报页面
-->

<template>
  <div class="page-main">
    <van-tabs v-model="active" color="#FBB13D" title-active-color="#FBB13D">
      <van-tab v-for="(item, index) in data" :key="index" :title="item.productName">
        <div class="img-list">
          <img v-for="(img, index) in item.urls" :key="index" :src="img" />
        </div>
      </van-tab>
    </van-tabs>

    <div v-if="Loading" class="loading"><img :src="loading" /></div>
  </div>
</template>

<script>
import ajax from '../../api/ajax';
import { getQueryString } from '../../api/restapi';
import loading from '../../assets/images/pending.gif'

export default {
  data() {
    return {
      loading,
      Loading: true,
      data:[],
      url: '',
    };
  },
  mounted() {
    document.title = '检验报告';
    this.id = getQueryString('id');
    this.getRecordInfo();
  },

  methods: {
    getRecordInfo() {
      ajax
        .Post({
          url: '/api/mall/u8c/selectBatchNoById',
          data: { id: this.id },
          timeout:20000,
        }).then(({ data: { success, data } }) => {
          this.Loading = false
          if (success) {
           this.data = data.map(item=>({
             ...item,
             urls: item.checkedReportUrl&&item.checkedReportUrl.split(',') || []
           }))
           console.log(this.data)
          } else {
            this.$message.error('数据请求失败')
          }
        })
    },
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
  font-size: 14px;
}

.loading {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  /* background: rgba(0, 0, 0, .2); */
}

.loading img {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.page-main{
  padding: 20px 10px;
}
.top-tip {
  width: 100%;
  height: 120px;
  line-height: 120px;
  color: crimson;
  font-size: 14px;
  text-align: center;
}
.img-list img{
  width:100%;
  margin-bottom: 10px;
}
</style>
